import { Link } from 'react-router-dom'
import { Logo } from './Logo'
import { useI18n } from '../i18n'

export function Footer() {
  const { t } = useI18n()
  return (
    <footer className="border-t border-brand-100/70 dark:border-brand-800/70 mt-24">
      <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-6 px-5 py-10 text-sm text-brand-600 dark:text-brand-300 md:flex-row">
        <Logo />
        <nav className="flex items-center gap-5">
          <Link to="/features" className="hover:text-brand-900 dark:hover:text-white">{t('nav.features')}</Link>
          <Link to="/discover" className="hover:text-brand-900 dark:hover:text-white">{t('nav.discover')}</Link>
          <Link to="/privacy" className="hover:text-brand-900 dark:hover:text-white">{t('footer.privacy')}</Link>
          <Link to="/terms" className="hover:text-brand-900 dark:hover:text-white">{t('footer.terms')}</Link>
        </nav>
        <p>© {new Date().getFullYear()} HorseSheli</p>
      </div>
    </footer>
  )
}
